const META_SCRIPT_ID = "orv-meta-pixel";
const GA_SCRIPT_ID = "orv-google-analytics";

let config = {};
let metaPixelId = "";
let googleAnalyticsId = "";

const isMetaPixelId = (value) => /^\d{5,25}$/.test(String(value || "").trim());
const isGoogleAnalyticsId = (value) => /^(G|GT)-[A-Z0-9]+$/i.test(String(value || "").trim());

export const initTracking = (settings = {}) => {
  config = settings;
  metaPixelId = String(settings.meta_pixel_id || "").trim();
  googleAnalyticsId = String(settings.google_analytics_id || "").trim();

  if (
    settings.meta_tracking_enabled !== false &&
    isMetaPixelId(metaPixelId) &&
    !document.getElementById(META_SCRIPT_ID)
  ) {
    const script = document.createElement("script");
    script.id = META_SCRIPT_ID;
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(script);

    window.fbq =
      window.fbq ||
      function fbq() {
        window.fbq.callMethod
          ? window.fbq.callMethod.apply(window.fbq, arguments)
          : window.fbq.queue.push(arguments);
      };
    if (!window._fbq) window._fbq = window.fbq;
    window.fbq.push = window.fbq;
    window.fbq.loaded = true;
    window.fbq.version = "2.0";
    window.fbq.queue = [];
    window.fbq("init", metaPixelId);
  }

  if (
    settings.google_tracking_enabled !== false &&
    isGoogleAnalyticsId(googleAnalyticsId) &&
    !document.getElementById(GA_SCRIPT_ID)
  ) {
    const script = document.createElement("script");
    script.id = GA_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(
      googleAnalyticsId
    )}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag =
      window.gtag ||
      function gtag() {
        window.dataLayer.push(arguments);
      };
    window.gtag("js", new Date());
    window.gtag("config", googleAnalyticsId, { send_page_view: false });
  }
};

const googleEventNames = {
  PageView: "page_view",
  ViewContent: "view_item",
  InitiateCheckout: "begin_checkout",
  Purchase: "purchase",
};

export const trackEvent = (eventName, parameters = {}) => {
  if (
    config.meta_tracking_enabled !== false &&
    isMetaPixelId(metaPixelId) &&
    typeof window.fbq === "function"
  ) {
    window.fbq("track", eventName, parameters);
  }

  if (
    config.google_tracking_enabled !== false &&
    isGoogleAnalyticsId(googleAnalyticsId) &&
    typeof window.gtag === "function"
  ) {
    window.gtag("event", googleEventNames[eventName] || eventName, parameters);
  }
};

export const trackPageView = () => {
  const page = {
    page_location: window.location.href,
    page_path: window.location.pathname + window.location.search,
    page_title: document.title,
  };
  trackEvent("PageView", page);
};

export const trackingIsConfigured = () => ({
  meta: isMetaPixelId(metaPixelId),
  google: isGoogleAnalyticsId(googleAnalyticsId),
});
